var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgSparkles = function SvgSparkles(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-2.117a.5.5 0 0 1 0-.946L8.5 8.883a2 2 0 0 0 1.437-1.437l2.117-6.135a.5.5 0 0 1 .946 0l2.117 6.135a2 2 0 0 0 1.437 1.437L22.689 11a.5.5 0 0 1 0 .946l-6.135 2.117a2 2 0 0 0-1.437 1.437L13 21.635a.5.5 0 0 1-.946 0zM20 3v4M22 5h-4M4 17v2M5 18H3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSparkles);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;